export const Url = {
    login: 'https://elbakyan.am/Server/login',
    existUser: 'https://elbakyan.am/Server/corona',
    logout: 'https://elbakyan.am/Server/logout',
    location: 'https://elbakyan.am/Server/location',
    city: 'https://elbakyan.am/Server/location/city',
    registration: 'https://elbakyan.am/Server/Reg',
    auto: 'https://elbakyan.am/Server/auto',
    model: 'https://elbakyan.am/Server/auto/model',
    addauto: 'https://elbakyan.am/Server/AddUserAuto',
    getUserAuto: 'https://elbakyan.am/Server/GetUserAuto',
    DeleteUserAuto: 'https://elbakyan.am/Server/DeleteUserAuto',
    UserUpdate: 'https://elbakyan.am/Server/UbdateUserData',
    service: 'https://elbakyan.am/Server/services',
    getscore: 'https://elbakyan.am/Server/GetScoreAccount',
    addscore: 'https://elbakyan.am/Server/AddScoreAccount',
    addproduct: 'https://elbakyan.am/Server/AddProduct'
}
